export default __webpack_public_path__ + "static/media/news57.eeb68f72.jpg";